require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./article-medicalnewstoday-treatment.json") })
        }
      }, "path---article-medicalnewstoday-treatment");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---article-medicalnewstoday-treatment!./.cache/json/article-medicalnewstoday-treatment.json
// module id = 353
// module chunks = 231608221292675